import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OrgContextService } from '../core/services/org-context.service';
import { ProductService } from '../core/services/product.service';

/**
 * Gate a route behind an organization's product access. Plan is DISABLED by
 * default — a route guarded with this only activates when the org's
 * `product-access/config` lists the product (set by an admin in the console).
 * Otherwise the user is sent to the product-disabled page.
 */
export function requireProductAccess(productId: string, fallbackUrl = '/product-disabled'): CanActivateFn {
  return async () => {
    const orgContext = inject(OrgContextService);
    const productService = inject(ProductService);
    const router = inject(Router);

    const org = orgContext.currentOrg();
    if (!org) return router.parseUrl('/new');

    const member = orgContext.currentMember();
    const roleId = member?.roleId || member?.role || null;

    const hasAccess = await productService.checkProductAccess(org.id, productId, roleId);
    return hasAccess || router.parseUrl(fallbackUrl);
  };
}
